module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxc-slider-bar",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, [_c('div', {
    ref: "bar-container",
    staticClass: "slider-bar-container",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.containerStyle))
  }, [_c('div', {
    staticClass: "range-bar",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.rangeBarStyle))
  }, [_c('div', {
    ref: "value-bar",
    staticClass: "value-bar",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.valueBarStyle))
  }, [_c('div')])]), _vm._v(" "), _c('div', {
    ref: "slide-block-1",
    staticClass: "slide-block",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.blockStyle1)),
    attrs: {
      "prevent-move-event": _vm.preventMoveEvent
    },
    on: {
      "touchstart": _vm._weexStartHandler1,
      "panstart": _vm._webStartHandler,
      "panmove": _vm._webMoveHandler1,
      "touchend": _vm._weexEndHandler,
      "horizontalpan": _vm.dispatchPan
    }
  }, [_c('div')]), _vm._v(" "), (_vm.range) ? _c('div', {
    ref: "slide-block-2",
    staticClass: "slide-block",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.blockStyle2)),
    attrs: {
      "prevent-move-event": _vm.preventMoveEvent
    },
    on: {
      "touchstart": _vm._weexStartHandler2,
      "panstart": _vm._webStartHandler,
      "panmove": _vm._webMoveHandler2,
      "touchend": _vm._weexEndHandler,
      "horizontalpan": _vm.dispatchPan
    }
  }, [_c('div')]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1797400a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1797400a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-slider-bar/index.vue
// module id = 229
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28